import gql from 'graphql-tag';
import CartListFragment from '@/queries/fragments/cartItems.gql.js';

export default gql`
    query getCustomerCart {
        customerCart {
            id
            ...CartListFragment
        }
    }
    ${CartListFragment}
`;
